import React, { useRef } from 'react'
import clsx from 'clsx'
import { Icon, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import * as R from 'ramda'
import Assets from 'app/configs/assetConfigs'
import { CameraIcon } from 'app/components/icons'
import apiConfigs from 'app/configs/apiConfigs'
import { resizeAvatar_250 } from 'commons/resizeImage'

const useStyles = makeStyles((theme) => ({
  inputImage: {
    width: '70px !important',
    height: '70px',
    minWidth: '70px !important',
  },
  image: {
    width: '70px',
    height: '70px',
  },
  borderGrey: {
    borderColor: 'rgb(153,153,153)',
  },
  iconDeleted: {
    right: '0.5rem',
    bottom: '0.25rem',
    backgroundColor: 'rgb(225,225,225)',
    color: 'rgb(153,153,153)',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconCheck: {
    right: '.25rem',
    top: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  error: {
    color: '#E53E3E',
    backgroundColor: '#FFDDDD',
  },
}))
const IMAGE_KIT = apiConfigs.cndUrl

export default (props) => {
  const {
    isLoading,
    onUpload,
    images,
    onSelect,
    onDelete,
    isError = false,
  } = props
  const classes = useStyles()
  const fileUpload = useRef(null)

  const handleUploadImage = () => {
    fileUpload.current.click()
  }

  return (
    <div
      className={clsx(
        'flex bg-white rounded-8 text-grey-100 overflow-x-auto space-x-5 p-5',
        isError ? 'border border-red-500' : 'border border-grey-input',
      )}
    >
      <div
        key="add-image-btn"
        htmlFor="upload-image"
        onClick={handleUploadImage}
        className={clsx(
          classes.borderGrey,
          'w-88 h-88 flex-none border-1 border-gray-200 rounded-5 flex justify-center items-center cursor-pointer',
        )}
      >
        <label className="absolute w-20 h-20">
          <CameraIcon
            classes={clsx(
              isLoading ? 'text-grey' : 'cursor-pointer',
              'text-3xl',
            )}
          />
        </label>
        <input
          type="file"
          ref={fileUpload}
          accept="image/png, image/jpg, image/jpeg, image/bmp, image/webp"
          className="opacity-0 w-88 h-88 hidden"
          id="upload-image"
          disabled={isLoading}
          onClick={(event) => {
            event.target.value = ''
            fileUpload.current.value = ''
          }}
          onChange={(event) => {
            onUpload(R.view(R.lensPath(['target', 'files']))(event))
          }}
        />
      </div>
      {!R.isEmpty(images) &&
        images.map((item, index) => (
          <div
            className="relative flex-none"
            key={`${index}-${R.prop('id', item)}`}
          >
            <div
              className={clsx(
                classes.borderGrey,
                'border-1 border-gray-200 rounded-5 cursor-pointer flex',
                R.prop('isSelected', item) &&
                  item.isErrorRatio &&
                  'border border-red border-2',
              )}
              onClick={() => {
                onSelect(item)
              }}
            >
              <img
                alt={R.prop('id', item)}
                className="h-88 w-88 object-cover rounded-5"
                src={`${IMAGE_KIT}/${resizeAvatar_250(R.prop('url', item))}`}
              />
            </div>
            {R.prop('isSelected', item) && (
              <div className={clsx(classes.iconCheck, 'absolute')}>
                <img
                  alt={'icon_default_image_post_social'}
                  className="mr-1 "
                  width={18}
                  height={18}
                  src={Assets.checkCorrect}
                />
              </div>
            )}
            <div
              className={clsx(
                classes.iconDeleted,
                'text-lg absolute cursor-pointer',
              )}
              onClick={() => onDelete(item)}
            >
              <Icon className="text-lg">deleted</Icon>
            </div>
          </div>
        ))}
      {isLoading && (
        <div
          key="box-loading"
          className={clsx(
            classes.image,
            classes.borderGrey,
            'border-solid border-2 rounded-lg mx-3 cursor-pointer w-88 h-88',
          )}
        >
          <div className="h-full flex justify-center items-center">
            <CircularProgress className="flex m-auto" size={20} thickness={5} />
          </div>
        </div>
      )}
    </div>
  )
}
